import { put } from "redux-saga/effects";

import { consoleLogError } from "../../utils/console";
import { _sharedActionsToc } from "./actions";
import { getBookToc } from "../saga-functions";

const scope = "Shared Saga TOC";

export function* _sharedWorkerFetchToc(action) {
  try {
    const bookIdOrigin = action.data;

    const toc = yield getBookToc(bookIdOrigin);

    if (toc) {
      yield put(_sharedActionsToc.setItem(bookIdOrigin, toc));
    }
    return toc;
  } catch (error) {
    consoleLogError(scope, "Error: ", error);
    return undefined;
  }
}
